import { ContextualControllerApi, ListResponseKeywordStatsBean, ListResponsePageUrlKeywordsBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

const asIsDate = (value: string): any => ({ toISOString: () => value })

class ContextualTargetingApi extends BaseApi {
    api: ContextualControllerApi

    constructor() {
        super()
        this.api = new ContextualControllerApi(configuration, configuration.basePath, this.fetch)
    }

    pageUrlKeywords(size: number = 20, page: number = 1, sort, search, keyword): Promise<ListResponsePageUrlKeywordsBean> {
        return this.call(() => this.api.pageUrlKeywords(search, keyword, { query: { size, page, sort } }))
    }

    keywordStats(size: number = 20, page: number = 1, sort, search: string | undefined, start: string, end: string): Promise<ListResponseKeywordStatsBean> {
        return this.call(() => this.api.keywordStats(search ?? '', asIsDate(start), asIsDate(end), { query: { size, page, sort } }))
    }
}

const contextualTargetingApi = new ContextualTargetingApi()
export default contextualTargetingApi


// WEBPACK FOOTER //
// ./src/component/app/contextualTargeting/ContextualTargetingApi.ts